import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { getCurrentUser } from 'helpers/Utils';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    TODOS_FETCH_ITEM,
    TODOS_ADD_ITEM,
    TODOS_DELETE_ITEM
} from './actions_def';
import {
    getToDoItemSuccess,
    getToDoItemError,
    addToDoItemSuccess,
    addToDoItemError,
    deleteToDoItemSuccess,
    deleteToDoItemError


} from './actions';


const apiUrl = servicePath;


const getToDoItemRequest = async () => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/task/', { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => (
                    {
                        id: item.rfc_id,
                        title: item.rfc_title,
                        date: moment(item.date_created).format("Do MMM YYYY"),
                        change_date: moment(item.date_modified).format("Do MMM YYYY (hh:mm)"),
                        end_date: moment(item.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                        status: item.rfc_status,
                        statusColor: 'primary'
                    }
                )
                )
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getToDoItem() {
    try {
        const response = yield call(getToDoItemRequest);
        yield put(getToDoItemSuccess(response));
    } catch (error) {
        yield put(getToDoItemError(error));
    }
}


const addToDoItemRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        var _user = getCurrentUser(); // JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (item.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        let _sendingPayload = {
            task_short_description: item.title,
            task_long_description: item.detail ? item.detail : ' ',
        };

        // console.log(_sendingPayload, getAccessToken());
        instance.post('/task/',
            _sendingPayload,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status)
                    }
                }
            }).catch((error) => {
                console.log(error)
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* addToDoItem({ payload }) {

    try {
        const response = yield call(addToDoItemRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(addToDoItemSuccess(response));
        }
        else {
            yield put(addToDoItemError(response));
        }
    } catch (error) {
        yield put(addToDoItemError(error));
    }
}


const deleteToDoRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        console.log(item)
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.delete('/task/' + item + '/',
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success" || response.data.status === "ok") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteToDoItem({ payload }) {
    // console.log(payload);
    try {
        const response = yield call(deleteToDoRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(deleteToDoItemSuccess(response));
        }
        else {
            yield put(deleteToDoItemError(response));
        }
    } catch (error) {
        yield put(addToDoItemError(error));
    }
}


export function* watchFetchItem() {
    yield takeEvery(TODOS_FETCH_ITEM, getToDoItem);
}

export function* watchAddItem() {
    yield takeEvery(TODOS_ADD_ITEM, addToDoItem);
}
export function* watchDeleteItem() {
    yield takeEvery(TODOS_DELETE_ITEM, deleteToDoItem);
}


export default function* rootSaga() {
    yield all([
        fork(watchAddItem),
        fork(watchFetchItem),
        fork(watchDeleteItem),
    ]);
}
